module.exports = __webpack_public_path__ + "img/no-invoice.e4b00508.png";